import {
  Table as CTable,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Box,
  HStack,
  Icon,
  Text,
  Center,
  Stack,
} from "@chakra-ui/react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa6";
import { useTable, Column } from "react-table";
import { DropDown } from "../DropDown/DropDown";
import { useEffect, useState } from "react";

export interface TableProps {
  data: any;
  columns: Column[];
  centered?: boolean;
  paginationEnabled?: boolean; // Add paginationEnabled prop
  intialRowsPerPage?: number;
  totalPages?: number;
  onPageSizeChange: (pageNumber: number, rowsPerPage: number) => void;
}

export const Table = ({
  columns,
  data,
  centered = false,
  paginationEnabled = true, // Default pagination to true
  intialRowsPerPage = 5,
  totalPages,
  onPageSizeChange,
}: TableProps) => {
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable({ columns, data });

  const [rowsPerPage, setRowsPerPage] = useState(intialRowsPerPage);
  const [currentPage, setCurrentPage] = useState(0);

  console.log("totalPages", totalPages);

  const rowsPerPageOptions = [
    {
      id: 5,
      component: <Text>{5}</Text>,
    },
    {
      id: 10,
      component: <Text>{10}</Text>,
    },
    {
      id: 15,
      component: <Text>{15}</Text>,
    },
  ];

  const onNext = () => {
    if (currentPage < (totalPages || Math.ceil(rows.length / rowsPerPage))) {
      onPageSizeChange(currentPage + 1, rowsPerPage);
      setCurrentPage(currentPage + 1);
    }
  };

  const onPrev = () => {
    if (currentPage) {
      onPageSizeChange(currentPage - 1, rowsPerPage);
      setCurrentPage(currentPage - 1);
    }
  };

  useEffect(() => {
    onPageSizeChange(currentPage, rowsPerPage);
  }, [rowsPerPage]);

  return (
    <Box fontSize={{ base: "16px", lg: "18px" }}>
      <Box maxW="100%" overflowX="auto">
        <CTable
          {...getTableProps()}
          bgColor="rgba(255, 255, 255, 0.05)"
          backdropFilter="blur(10px)"
          borderWidth={1}
          borderColor="rgba(255, 255, 255, 0.1)"
          borderRadius={4}
        >
          <Thead bgColor="rgba(118, 82, 247, 0.3)" borderRadius="12px">
            {headerGroups.map((headerGroup, index) => (
              <Tr {...headerGroup.getHeaderGroupProps()} key={index}>
                {headerGroup.headers.map((column, index) => (
                  <Th {...column.getHeaderProps()} key={index} color="white">
                    <Center justifyContent={centered ? "center" : "flex-start"}>
                      <Text fontWeight="600" color="white">{column.render("Header")}</Text>
                    </Center>
                  </Th>
                ))}
              </Tr>
            ))}
          </Thead>
          <Tbody {...getTableBodyProps()}>
            {rows.length > 0 ? (
              rows.map((row, index) => {
                prepareRow(row);
                return (
                  <Tr {...row.getRowProps()} key={index}>
                    {row.cells.map((cell, index) => (
                      <Td {...cell.getCellProps()} key={index} color="white">
                        {cell.render("Cell")}
                      </Td>
                    ))}
                  </Tr>
                );
              })
            ) : (
              <Tr>
                <Td colSpan={columns.length} textAlign="center" py={16} color="rgba(255, 255, 255, 0.6)">
                  <Text fontSize="18px">
                    Data not available
                  </Text>
                </Td>
              </Tr>
            )}
          </Tbody>
        </CTable>
      </Box>

      {paginationEnabled && (
        <Box
          backgroundColor="rgba(255, 255, 255, 0.05)"
          backdropFilter="blur(10px)"
          borderColor="rgba(255, 255, 255, 0.1)"
          borderWidth="1px"
          borderTopWidth="0px"
          borderBottomRadius="20px"
          color="white"
        >
          <HStack justifyContent="space-between" p={3}>
            <HStack px={3}>
              <Text fontSize="14px" noOfLines={1}>
                Show rows per page
              </Text>
              <DropDown
                selected={{
                  id: rowsPerPage,
                  component: <Text>{rowsPerPage}</Text>,
                }}
                title={<></>}
                options={rowsPerPageOptions}
                onOptionChange={(id) => setRowsPerPage(id)}
              />
            </HStack>

            <Stack
              direction={{ base: "column", sm: "row" }}
              alignItems="center"
              gap={6}
            >
              <Text>
                Page {currentPage + 1} of{" "}
                {totalPages || Math.ceil(rows.length / rowsPerPage)}
              </Text>
              <HStack gap={6} px={4}>
                <Icon
                  as={FaChevronLeft as React.ElementType}
                  cursor={currentPage > 0 ? "pointer" : "default"}
                  color={currentPage > 0 ? "white" : "rgba(255, 255, 255, 0.3)"}
                  _hover={currentPage > 0 ? { color: "brand.400" } : {}}
                  onClick={onPrev}
                />
                <Icon
                  as={FaChevronRight as React.ElementType}
                  cursor={
                    currentPage <
                    (totalPages || Math.ceil(rows.length / rowsPerPage)) - 1
                      ? "pointer"
                      : "default"
                  }
                  color={
                    currentPage <
                    (totalPages || Math.ceil(rows.length / rowsPerPage)) - 1
                      ? "white"
                      : "rgba(255, 255, 255, 0.3)"
                  }
                  _hover={
                    currentPage <
                    (totalPages || Math.ceil(rows.length / rowsPerPage)) - 1
                      ? { color: "brand.400" }
                      : {}
                  }
                  onClick={onNext}
                />
              </HStack>
            </Stack>
          </HStack>
        </Box>
      )}
    </Box>
  );
};
